export default {
  hero: { eyebrow: "Concorso Studio · Modulo Premium", title: "Costruisci competizioni d'elite che si sentono come eventi di trasmissione.", subtitle: "Progettare esperienze di golf, racchetta e competizione ibrida con superfici sponsorizzate premium, storytelling in tempo reale e flussi di lavoro di controllo pronti al lancio." },
  actions: { create: "Crea competizione", creating: "Creare...", demo: "Modalità Demo di lancio", addScreen: "Aggiungere lo schermo", createGroup: "Creare gruppo di schermo", newCampaign: "Nuova campagna di sponsorizzazione", previewBroadcast: "Anteprima Trasmissione", startBroadcast: "Trasmissione", pauseBroadcast: "Pausa trasmissione", pushAnnouncement: "Annuncio di spinta", finalsMode: "Inserire la modalità Finals" },
  metrics: { activeCompetitions: "Concorsi attivi", screensSynced: "Scenari sincronizzati", sponsorsLive: "Sponsor Live", viewersNow: "Live Viewers (Ora)", totalScreens: "Schermi totali", onlineScreens: "Schermi online", activeGroups: "Gruppi di Schermo attivi", campaignsToday: "Le campagne vivono oggi", tickerEnabled: "Ticker abilitato", broadcastingNow: "Trasmissione ora", matchesLive: "Partite dal vivo", activeBroadcasts: "Trasmissioni attive", announcementsToday: "Annunci Oggi", spotlightEvents: "Eventi alla ribalta", viewers: "Osservatori" },
  builder: { journey: "Viaggio del costruttore", readiness: "{value} % pronto per il lancio", tip: "Suggerimento: La console di lancio aggiorna dal vivo mentre si progetta questo evento.", hybridHelp: "Modalità ibrida sbloccata: progettare un flusso di competizione in fase con momenti di punteggio unificato.", golfPresetHelp: "Preimpostazioni di golf curate pronte per il lancio.", racquetPresetHelp: "Preimpostazioni racchette curate pronte per il lancio.", stageGolf: "Fase 1: Golf Seeding", stageRacquet: "Fase 2: Bracchette di racchetta", stageFinals: "Fase 3: Finali Unificati" },
  formats: { matchPlayDescription: "Momento testa a testa, buca per buca." },
  journey: { sport: "Sport sport", format: "Formato", setup: "Impostazione", rules: "Regole", sponsors: "Sponsor", launch: "Lancio" },
  screens: { eyebrow: "Sala di controllo radio", title: "Studio di gestione dello schermo", subtitle: "Controllare ogni visualizzazione locale, monetise sponsor inventario, e orchestrare premium in-club storytelling.", lastSeen: "Ultimo accesso {value}", noHeartbeat: "Nessun battito cardiaco rilevato ancora" },
  live: { title: "Live concorsi studio", subtitle: "Comandare partite dal vivo, trasmissioni di controllo e orchestrare storytelling in tempo reale." },
  announcements: { finalGroupCamera: "Gruppo finale che entra firma par-3 finestra telecamera dal vivo.", courtTieBreak: "Corte 1 semifinale che entra in decisivo set tie-break.", hospitalityOpen: "Ospitalità terrazza ora aperta per gli spettatori finali." },
  spotlight: { onFire: "Il fuoco", closingHole: "buca di chiusura", bounceBack: "Momento di rimbalzo" },
  timeline: { ethanBirdie15: "Ethan birdie su 15", crowdSurge: "L'impulso della folla in campo centrale", lucasReplay: "Riproduzione di chip-in lucas", semiFinalTieBreak: "Semifinale tie-break inizia", spotlightHole16: "Interruttore di luce a buca 16" },
  canonical: { sports: { golf: "Golf", racquet: "Racchetta", multiSport: "Multi-Sport" }, statuses: { draft: "Bozza", openForEntries: "Aperto per le voci", entriesClosed: "Voci chiuse", inProgress: "In corso", completed: "Completato", cancelled: "Annullato" }, participants: { individual: "Individuale", team: "Squadra", hybrid: "Ibrido" }, broadcastModes: { leaderboardFocus: "Focus leaderboard", matchFocus: "Focus sulla partita", playerSpotlight: "Spotlight del giocatore", finalsMode: "Modalità delle finali" }, previewModes: { leaderboardFocus: "Focus leaderboard", sponsorTicker: "Testo scorrevole sponsor", matchCentre: "Centro di corrispondenza", welcomeScreen: "Schermo di benvenuto", splitView: "Vista di Spalato", sponsorAdvertCard: "Sponsor carta pubblicitaria", playerSpotlight: "Spotlight del giocatore" }, tickerThemes: { darkNeon: "Neon nero", championshipGold: "Campionato d'oro", clubClassic: "Club Classico" }, tickerSpeeds: { slow: "Piano.", standard: "Standard", fast: "Veloce." }, matchStatuses: { live: "In diretta", upcoming: "Prossimo", completed: "Completato" }, screenStatuses: { online: "Online Online", offline: "Linea offline" }, contestTypes: { closestToPin: "Più vicino al Pin", longestDrive: "Guida più lunga" }, fantasyFormats: { salaryCap: "Tappo salato", pickPlayers: "Scegli i giocatori" } },
  validation: { nameRequired: "Il nome della concorrenza è richiesto.", sportRequired: "Si prega di scegliere uno sport.", typeRequired: "Si prega di scegliere un tipo di competizione.", startRequired: "La data di inizio è richiesta.", missingTitle: "Campi obbligatori mancanti", missingDescription: "Si prega di completare i campi evidenziati prima di creare la concorrenza." },
  errors: { create: "Incapace di creare la concorrenza", review: "Si prega di rivedere i dettagli e riprovare." },
  toasts: { created: "Concorrenza", createdDescription: "La tua competizione è stata salvata come bozza ed è pronta per i prossimi passi." },
  screenToasts: { missingClub: "contesto del club mancante", missingClubDescription: "Non riesco a risolvere il codice del club.", createError: "Incapace di creare lo schermo", refreshError: "In grado di aggiornare il codice", saveError: "Incapace di salvare la schermata", updated: "Schermo aggiornato", disconnectError: "Incapace di scollegare", disconnected: "Dispositivo disconnesso", reconnectError: "Incapace di generare codice di ricollegamento", retry: "Riprova." },
  clipboard: { copied: "Affrontato", failed: "Copia fallita", manual: "Si prega di copiare il link manualmente.", screenLinkCopied: "Schermo link copiato", linkFailed: "Non è possibile copiare il link" },
  confirmations: { deleteContest: "Sei sicuro di voler eliminare questo concorso?", removePlayer: "Questo rimuoverà il giocatore dalla concorrenza.", overwritePairings: "Questo sovrascriverà eventuali accoppiamenti esistenti.", clearTeeTimes: "Questo sarà chiaro tutti i tempi, sei sicuro?" },
  accessibility: { editContest: "Modifica del concorso", deleteContest: "Cancella concorso", editEntry: "Modificare la voce della concorrenza", deleteEntry: "Eliminare la voce della concorrenza", copyClubCode: "Copia il codice del club", copyPairingUrl: "Copiare l'URL di accoppiamento", copyScreenUrl: "Copia l'URL" },
  preview: { assignedCompetition: "Concorrenza assegnata", scheduledDay: "Programmato · Giorno 1 di 3", liveUpdates: "Aggiornamenti live della classifica e punteggio on-course", presentedByPartners: "Presentato da Club Partners", presentedBy: "Presentato da {sponsor}", dayProgress: "Giorno {day} di {total}", tickerFallback: "Privana ticker broadcast · aggiornamenti in diretta da seguire a breve", frontOfHouse: "Fronte di Casa", awaitingAssignment: "Risvegliare l'assegnazione della concorrenza", standby: "In attesa", graphicsReadyNext: "Grafica di trasmissione pronta per il prossimo inizio di competizione.", broadcast: "Concorrenza", liveCoverage: "Copertura della concorrenza dal vivo", graphicsReady: "grafica broadcast pronto", clubhouse: "Club", welcome: "Benvenuti al Privana Club", competitionUpdates: "Aggiornamenti della concorrenza dal vivo", stayTuned: "Restate sintonizzati per le modifiche della classifica" },
  copy: {
    "competition_not_found": "Concorso non trovato",
    "back_to_competitions": "Torna a Competizioni",
    "back_to_all_competitions": "Torna a Tutte le competizioni",
    "sponsored_by": "Sponsorizzato da:",
    "leaderboard": "Classifica dei leader",
    "entries": "Voci (",
    "tee_sheet": "Foglio delle partenze",
    "contests": "Concorsi",
    "fantasy": "Fantasia",
    "signage": "Segnale",
    "live_leaderboard": "Leadership dal vivo",
    "no_scores_submitted_yet": "Nessun punteggio presentato ancora.",
    "pos": "Pos",
    "player": "Giocatore",
    "h_cap": "H.cap",
    "total": "Totale",
    "live": "IN DIRETTA",
    "competition_feed": "Nutrizione della concorrenza",
    "venue": "Vendite",
    "scoring_feed_connected_awaiting_first_results": "Feed di punteggio collegato · in attesa dei primi risultati",
    "fantasy_leaderboard": "Leadership della fantasia",
    "rank": "Rango di grado",
    "member": "Socio",
    "team_name": "Nome squadra",
    "points": "Punti",
    "fantasy_golf_setup": "Fantastico Golf Setup",
    "configure_the_fantasy_game_for_this_competition": "Configurare il gioco fantasy per questa competizione.",
    "edit_configuration": "Modifica configurazione",
    "format": "Formato:",
    "team_size": "Dimensione squadra:",
    "captain": "Capitano:",
    "no_fantasy_game_configured_yet": "Nessun gioco di fantasia configurato ancora.",
    "fantasy_game_configuration": "Configurazione del gioco Fantasy",
    "team_size_2": "Dimensione squadra",
    "picks_lock_time": "Picks Tempo di bloccaggio",
    "enable_captain_2x_points": "Abilitare il capitano (2x punti)",
    "prize_pool_description": "Premio Piscina Descrizione",
    "cancel": "Annulla",
    "save_configuration": "Salva configurazione",
    "on_course_contests": "Concorsi On-Course",
    "manage_special_contests_like_longest_drive": "Gestisci concorsi speciali come Longest Drive.",
    "new_contest": "Nuovo Concorso",
    "hole": "- Hole!",
    "winner": "Vincitore:",
    "no_winner_declared_yet": "Nessun vincitore ha ancora dichiarato.",
    "no_on_course_contests_created_yet": "Nessun concorso on-course ancora creato.",
    "contest_type": "Tipo di prova",
    "closest_to_the_pin": "Più vicino al Pin",
    "longest_drive": "Guida più lunga",
    "hole_number": "Numero del buca",
    "winner_2": "Vincitore",
    "select_winner": "Seleziona il vincitore",
    "none": "Nessuno",
    "result": "Risultato",
    "e_g_315_yards_or_3ft_2in": "ad esempio, 315 metri o 3ft 2in",
    "save_contest": "Salvare il Concorso",
    "template": "Modello",
    "device_preview": "Anteprima del dispositivo",
    "contest_winners": "Contest vincenti",
    "on_course_contest_results": "Risultati del Concorso On-Course",
    "sponsored_by_2": "Sponsorizzato da",
    "contest_winners_will_be_announced_soon": "I vincitori del concorso saranno annunciati presto.",
    "last_updated": "Ultimo aggiornamento:",
    "welcome_to_the": "Benvenuto al",
    "waiting_for_scores": "In attesa di punteggi...",
    "format_studio": "Studio formati",
    "demo_ready": "Demo pronta",
    "hybrid_competition_flow": "Flusso della concorrenza ibrido",
    "popular": "Popolari",
    "competition_blueprint": "Competizione",
    "shape_identity_schedule_and_participation_with_a_broadcast_grade": "Forma identità, programma e partecipazione con una configurazione di livello broadcast.",
    "event_identity": "Identità degli eventi",
    "competition_name": "Nome della concorrenza",
    "privana_signature_invitational": "Privana Firma invitazionale",
    "short_description": "Breve descrizione",
    "a_multi_discipline_premium_member_event_with_live_coverage": "Un evento premium multidisciplinare con copertura live e integrazioni di sponsor.",
    "venue_location": "Luogo / luogo",
    "championship_course_center_court": "Corso di campionato + Centro Corte",
    "schedule_participation": "Programma e partecipazione",
    "start_date": "Data di inizio",
    "end_date": "Data di fine",
    "max_participants": "Max partecipanti",
    "mode": "Modalità",
    "individual": "Individuale",
    "team": "Squadra",
    "hybrid": "Ibrido",
    "rules_scoring_modules": "Regole e moduli di punteggio",
    "compose_scoring_logic_blocks_that_feel_ready_for_real": "Componi blocchi di logica di punteggio che si sentono pronti per le operazioni reali.",
    "core_scoring_controls": "Controlli di punteggio core",
    "live_scoring_enabled": "Live punteggio abilitato",
    "gross_net_leaderboard": "Centrale lorda + netta",
    "round_match_days": "Giorno di partita",
    "golf_engine": "Motore di golf",
    "handicap_allowances": "Indennità di handicap",
    "tie_break_policy": "Politica di Tie-break",
    "back_nine": "Indietro",
    "last_6_holes": "Ultimi 6 Holes",
    "sudden_death_playoff": "Improvvisa morte playoff",
    "racquet_engine": "Motore di racchetta",
    "set_format": "Formato set",
    "best_of_3": "Il meglio di 3",
    "best_of_5": "Il meglio di 5",
    "fast_4": "Veloce 4",
    "points_structure": "Struttura dei punti",
    "standard": "Standard",
    "golden_point_deuce": "Deuce punto d'oro",
    "timed_match_format": "Formato di corrispondenza tempo",
    "sponsorship_branding_studio": "Sponsorizzazione & Branding Studio",
    "competition_page": "Pagina della concorrenza",
    "tv_ticker": "Testo scorrevole TV",
    "screen_adverts": "Pubblicità dello schermo",
    "screen_overlays": "Sovrapposizioni dello schermo",
    "position_sponsor_inventory_across_pages_tickers_and_premium_screen": "Posizionare l'inventario dello sponsor su pagine, ticker e superfici dello schermo premium.",
    "title_sponsor": "Sponsor del titolo",
    "logo_media_slot": "Logo / slot media",
    "1200x600_png_svg": "1200x600 · PNG/SVG",
    "supporting_sponsor_1": "Sponsor di supporto 1",
    "supporting_sponsor_2": "Sponsor di supporto 2",
    "commercial_surface_preview": "Anteprima di superficie commerciale",
    "competition_header": "Intestazione della concorrenza",
    "ticker_rotation": "Rotazione ticker",
    "sponsor_loop": "CICLO SPONSOR",
    "launch_console": "Console di lancio",
    "review_launch": "Rivedi e avvia",
    "your_premium_event_package_ready_for_broadcast_and_member": "Il pacchetto premium per eventi, pronto per la trasmissione e il rilascio dei soci.",
    "competition": "Competizione",
    "saved_id": "ID salvato:",
    "max": "·",
    "launch_readiness": "Avviare la prontezza",
    "all_required_launch_fields_are_complete": "Tutti i campi di lancio richiesti sono completi.",
    "save_draft": "Salvare il progetto",
    "preview_screens": "Schermi di anteprima",
    "launch_confidence": "Avviare la fiducia:",
    "complete_identity_and_scheduling_fields_to_finalize_a_fully": "IdentitÃ completa e campi di programmazione per finalizzare un pacchetto di competizione completamente pronto.",
    "screen_inventory": "Inventario dello schermo",
    "select_a_screen_to_load_its_live_preview_and": "Selezionare una schermata per caricare l'anteprima dal vivo e le superfici di comando.",
    "no_screens_added_yet": "Non sono ancora stati aggiunti schermi",
    "create_and_pair_your_first_competition_screen_to_unlock": "Creare e abbinare la prima schermata di competizione per sbloccare l'inventario dal vivo, la telemetria di stato e il controllo mirato.",
    "one_time_pairing_flow_for_tvs_and_signage_laptops": "• Flusso di accoppiamento di una volta per TV e computer portatili di segnaletica",
    "persistent_screen_sessions_with_heartbeat_presence": "• Sessioni di schermo persistenti con presenza battito cardiaco",
    "layout_and_sponsor_orchestration_from_one_control_room": "• Layout e sponsor orchestrazione da una sala di controllo",
    "add_screen": "Aggiungere lo schermo",
    "manage_screen": "Gestione della schermata",
    "layout": "Layout:",
    "source": "Fonte:",
    "ticker": "Armadietto:",
    "ad_loop": "Annuncio Loop:",
    "live_preview_canvas": "Live Anteprima tela ·",
    "ticker_configuration": "Configurazione di Ticker",
    "broadcast_footer_controls_for_sponsors_match_updates_and_urgent": "Controlli di piè di trasmissione per sponsor, aggiornamenti di corrispondenza e annunci urgenti.",
    "ticker_enabled": "Ticker abilitato",
    "theme": "Tema",
    "speed": "Velocità",
    "logo_mode": "Modalità logo",
    "sponsor_logos_only": "Loghi dello sponsor solo",
    "logos_text": "Logos + testo",
    "include_competition_updates": "Includere gli aggiornamenti della concorrenza",
    "urgent_announcements": "Annunci urgenti",
    "ticker_sim_rolex_finals_countdown_court_1_live_in": "[Ticker Sim] Rolex Finals Countdown · Court 1 live in 04:00 · Ospitalità partner vetrina inizia alle 18:00.",
    "advert_scheduler_playlist": "Pianificazione pubblicità e playlist",
    "design_sponsor_playback_loops_and_intermission_placements_with_commercial": "Progettare circuiti di riproduzione dello sponsor e posizionamenti di intermissione con chiarezza commerciale.",
    "assigned": "Assegnato:",
    "playlist_timeline": "Timeline della lista dei giochi",
    "screen_groups": "Gruppi di Schermo",
    "deploy_synchronized_layouts_and_sponsor_packages_to_grouped_venue": "Distribuire layout sincronizzati e pacchetti di sponsor per zone di sede raggruppate.",
    "screens": "schermi ·",
    "active_campaigns": "campagne attive",
    "assign_layout": "Assegnare layout",
    "push_campaign": "Spingere la campagna",
    "content_rotation_timeline": "Contenuto Rotazione Timeline",
    "static_demo_loop_builder_showing_proportioned_broadcast_sequencing": "Generatore di loop demo statico che mostra sequenziamento di trasmissione proporzionale.",
    "s": "- Sì.",
    "loop_length": "Lunghezza del cerchio:",
    "s_auto_repeats_continuously_on_assigned_screens": "s · Autoripeti continuamente sugli schermi assegnati.",
    "sponsor_campaign_manager": "Responsabile della campagna",
    "sales_friendly_campaign_snapshots_for_sponsors_targets_frequencies_and": "Istantanee di campagna di vendita-friendly per sponsor, obiettivi, frequenze e priorità.",
    "type": "Tipo:",
    "competition_2": "Concorrenza:",
    "dates": "Date:",
    "targets": "Obiettivi:",
    "playback": "Riproduzione:",
    "priority": "Priorità:",
    "live_override_console": "Console di modifica in diretta",
    "instant_operational_controls_for_high_pressure_moments": "Controlli operativi istantanei per momenti di alta pressione.",
    "add_competition_screen": "Aggiungere lo schermo della concorrenza",
    "create_a_screen_and_generate_a_short_lived_one": "Creare uno schermo e generare un codice di accoppiamento una volta di breve durata.",
    "pair_your_screen_first": "Abbina il tuo schermo prima",
    "follow_these_quick_steps_on_the_target_display_before": "Seguire questi passaggi rapidi sul display di destinazione prima di creare questa schermata.",
    "step_1_open_this_on_your_screen": "Passo 1 · Aprire questo sullo schermo",
    "step_2_enter_your_club_code": "Passo 2 · Inserisci il codice del club",
    "screen_name_display_name": "Nome dello schermo / Nome dell'esposizione",
    "this_helps_your_team_identify_the_display_location_quickly": "Questo aiuta il team a identificare rapidamente la posizione del display.",
    "active_one_time_code": "Codice attivo di una volta",
    "code_refreshes_in": "Codice rinfresca in",
    "current_code_expires_at": "Il codice attuale scade a",
    "club_code": "Codice Club",
    "base_pairing_url": "URL di accoppiamento di base",
    "unique_screen_url": "URL della schermata unica",
    "open": "Apri",
    "on_the_target_screen_enter_club_code": "sulla schermata di destinazione, inserire il codice del club",
    "then_enter_the_one_time_code": ", quindi inserire il codice una volta.",
    "done": "Fine",
    "edit_broadcast_behavior_and_device_state": "Modificare il comportamento di trasmissione e lo stato del dispositivo.",
    "display": "Visualizza",
    "display_name": "Nome dell'esposizione",
    "location": "Luogo",
    "screen_link": "Collegamento dello schermo",
    "copy_the_direct_display_url_for_this_screen": "Copiare l'URL di visualizzazione diretta per questa schermata.",
    "copy_screen_link": "Copiare il link della schermata",
    "broadcast": "Trasmissione",
    "layout_preset": "Preimpostazione del layout",
    "select_layout_preset": "Selezionare la configurazione di layout",
    "unknown_preset_saved": "Preimpostazioni sconosciute (salvo):",
    "assigned_competition_id": "ID gara assegnata",
    "device": "Dispositivo",
    "orientation": "Orientamento",
    "resolution": "Risoluzione",
    "group_id": "ID gruppo",
    "messaging": "Messaggero",
    "standby_message": "Messaggio in attesa",
    "toggles": "Occhiali",
    "public_facing": "Rivestimento pubblico",
    "reconnect_screen": "Schermo di connessione",
    "use_this_one_time_code_to_pair_the_existing": "Utilizzare questo codice una volta per associare nuovamente la schermata esistente.",
    "one_time_code": "Codice una volta",
    "loading_managed_screens": "Caricamento di schermi gestiti...",
    "create_and_pair_your_first_screen_to_unlock_live": "Creare e abbinare la prima schermata per sbloccare live ticker, pubblicizzare la programmazione e i controlli di layout.",
    "live_match_selector": "Selezionatore di corrispondenza dal vivo",
    "choose_the_active_match_feed_for_command_operations": "Scegliere il feed match attivo per le operazioni di comando.",
    "status": "· Stato:",
    "broadcast_mode": "Modalità di trasmissione",
    "select_mode": "Selezionare la modalità",
    "player_spotlight": "Spotlight del giocatore",
    "current_leader": "Leader attuale ·",
    "featured_live": "· In primo piano dal vivo",
    "live_ticker": "Testo scorrevole in diretta:",
    "leaderboard_control_panel": "Pannello di controllo Leaderboard",
    "match_control_panel": "Pannello di controllo di corrispondenza",
    "announcements_panel": "Pannello annunci",
    "type_announcement": "Tipo di annuncio...",
    "push_announcement": "Annuncio di spinta",
    "spotlight_queue_panel": "Pannello di coda di luce",
    "push_to_broadcast": "Spingere a trasmettere",
    "remove": "Rimuovi",
    "match_timeline_panel": "Pannello Timeline di corrispondenza",
    "live_sequence_of_score_updates_events_and_highlight_triggers": "Sequenza dal vivo di aggiornamenti, eventi e trigger di evidenziazione.",
    "production_critical_actions_for_high_pressure_broadcast_control": "Azioni di produzione-critiche per il controllo di trasmissione ad alta pressione.",
    "manage_pairings_and_tee_times": "Gestisci gli abbinamenti e i tempi dei tee.",
    "auto_generate": "Genera automaticamente",
    "clear_sheet": "Foglio trasparente",
    "tee_time": "Orario di partenza",
    "players": "Giocatori",
    "tee_sheet_has_not_been_generated": "Il foglio di Tee non è stato generato.",
    "search_members": "I soci della ricerca...",
    "no_members_found": "Nessun socio trovato.",
    "selected": "Selezionato:",
    "competition_entries": "Voci della concorrenza",
    "manage_participants_for_this_event": "Gestire i partecipanti per questo evento.",
    "add_participants": "Aggiungi i partecipanti",
    "player_name": "Nome del giocatore",
    "h_cap_index": "Indice h'cap",
    "playing_h_cap": "Giocare a H'cap",
    "payment": "Pagamento",
    "actions": "Azioni",
    "no_entries_yet": "Non ci sono ancora voci.",
    "edit_entry": "Modifica dell'iscrizione",
    "handicap_index": "Indice Handicap",
    "save_changes": "Salvare le modifiche",
    "add_new_participants": "Aggiungi nuovi partecipanti",
    "members": "Soci",
    "h_cap_index_2": "Indice h'cap",
    "next": "Avanti",
    "back": "Indietro",
    "save_participants": "Salvare i partecipanti",
    "starting_times": "Tempi di partenza",
    "tee_times_have_not_been_assigned_yet": "I tempi dei denti non sono ancora stati assegnati.",
    "golf": "Golf",
    "precision_scoring_and_marquee_course_storytelling": "Scontro di precisione e intagliamento del corso.",
    "ideal_for_member_majors_invitationals_and_broadcast_ready_rounds": "Ideale per i principali soci, gli inviti e i giri pronti per la trasmissione.",
    "racquet": "Racchetta",
    "tennis_padel_and_racquet_leagues_in_one_flow": "Leghe di tennis, padel e racchet in un unico flusso.",
    "built_for_ladders_tournaments_and_club_vs_club_showcases": "Costruito per scale, tornei e vetrine club-vs-club.",
    "multi_sport": "Multi-Sport",
    "a_premium_hybrid_event_engine_for_signature_championships": "Un motore di eventi ibrido premium per i campionati di firma.",
    "combine_golf_racquet_stages_with_unified_club_wide_storytelling": "Combinare le fasi di golf + racchet con unified club-wide storytelling.",
    "stableford": "Stableford",
    "points_by_hole_with_handicap_friendly_pacing": "Punti per buca con pacing per disabili.",
    "strategic_fast": "Strategico · Veloce",
    "stroke_play": "Gioco di tiro",
    "classic_aggregate_scoring_across_rounds": "Classico aggregato che segna attraverso i giri.",
    "traditional_premium": "Tradizionale · Premium",
    "match_play": "Gioco d'azzardo",
    "dramatic_broadcast": "Dramatico · Trasmissione",
    "best_ball_scramble": "Miglior Scramblea Ball",
    "team_creativity_with_best_shot_selection": "Team creativitÃ con selezione migliore.",
    "social_team_energy": "Sociale · Team Energy",
    "wolf": "Lupo",
    "rotating_strategy_and_decision_pressure_each_hole": "Ruotare la strategia e la pressione della decisione ogni buca.",
    "dynamic_interactive": "Dinamica · Interattivo",
    "round_robin": "Robin",
    "balanced_fixture_grid_with_standings_momentum": "Griglia di fissaggio bilanciata con slancio di stabilitÃ .",
    "fair_consistent": "Equo · Coerente",
    "knockout": "Bussare",
    "single_elimination_bracket_with_spotlight_matches": "Staffa di eliminazione singola con fiammiferi di faretto.",
    "fast_high_stakes": "Veloce · High Stakes",
    "double_elimination": "Doppia eliminazione",
    "second_life_pathway_with_stronger_parity": "Secondo percorso di vita con una parità più forte.",
    "competitive_extended": "Competizione · Estesa",
    "ladder_league": "Lega di scale",
    "challenge_ladder_for_season_long_movement": "Sfida scala per movimento lungo la stagione.",
    "persistent_engaging": "Persistente · Engaging",
    "team_league": "Lega di squadra",
    "squad_fixtures_with_tactical_lineups": "Squadra con schieramenti tattici.",
    "club_pride_tactical": "Club orgoglio · tattica",
    "sport": "Sport sport",
    "format_2": "Formato",
    "setup": "Impostazione",
    "rules": "Regole",
    "sponsors": "Sponsor",
    "launch": "Lancio",
    "layout_1": "Telaio 1",
    "main_feed_with_right_side_leaderboard_rail_and_live": "Mangimi principali con guida a destra e ticker live inferiore a terzo",
    "leaderboard_focus": "Focus leaderboard",
    "sponsor_ticker": "Testo scorrevole sponsor",
    "match_centre": "Centro di corrispondenza",
    "welcome_screen": "Schermo di benvenuto",
    "split_view": "Vista di Spalato",
    "sponsor_advert_card": "Sponsor carta pubblicitaria",
    "video_advert": "Annuncio pubblicitario",
    "every_3_mins": "Ogni 3 minuti",
    "live_2": "In diretta",
    "bar_lounge_lobby": "Bar e lounge, hall",
    "image_advert": "Pubblicità con immagine",
    "every_loop": "Ogni anello",
    "queued": "In coda",
    "golf_areas": "Aree di golf",
    "full_screen_takeover": "Acquisizione a pieno titolo",
    "top_of_hour": "In cima all'ora",
    "all_public_screens": "Tutti gli schermi pubblici",
    "intermission_card": "Scheda di ammissione",
    "between_matches": "Tra le partite",
    "draft": "Bozza",
    "racquet_areas": "Aree di racchetta",
    "sponsor_slate": "Sponsor alato",
    "every_5_mins": "Ogni 5 minuti",
    "reception_lobby": "Reception e hall",
    "bar_lounge": "Bar e lounge",
    "leaderboard_focus_2": "Focus leaderboard",
    "reception_lobby_2": "Reception e hall",
    "welcome_screen_2": "Schermo di benvenuto",
    "golf_areas_2": "Aree di golf",
    "clubhouse_mixed_feed": "Clubhouse Feed misto",
    "racquet_areas_2": "Aree di racchetta",
    "match_centre_2": "Centro di corrispondenza",
    "all_public_screens_2": "Tutti gli schermi pubblici",
    "finals_day_mode": "Modalità giorno delle finali",
    "fixtures": "Apparecchiature",
    "sponsor_reel": "Sequenza sponsor",
    "match_spotlight": "Partita in evidenza",
    "club_promo": "Promozione del club",
    "premium_brand_loop": "Premium marchio loop",
    "all_public_screens_3": "Tutti gli schermi pubblici",
    "every_4_mins": "Ogni 4 minuti",
    "active": "Attivo",
    "equipment_launch": "Lancio di attrezzature",
    "golf_areas_3": "Aree di golf",
    "every_6_mins": "Ogni 6 minuti",
    "lifestyle_spotlight": "Spotlight stile di vita",
    "bar_lounge_2": "Bar e lounge",
    "hourly_takeover": "Assunzione oraria",
    "scheduled": "Programmato",
    "wellness_card": "Carta Benessere",
    "racquet_areas_3": "Aree di racchetta",
    "every_loop_2": "Ogni anello",
    "leaderboard_focus_3": "Focus leaderboard",
    "live_leaderboard_dominance": "Dominio della classifica dal vivo",
    "scores_stay_central_with_a_compact_sponsor_ribbon_and": "Gli score rimangono centrali con un nastro di sponsor compatto e un piè di rotazione.",
    "sponsor_ticker_2": "Testo scorrevole sponsor",
    "sponsor_led_ticker_mode": "Modalità ticker sponsorizzato",
    "commercial_headlines_lead_the_footer_while_updates_pulse_between": "I titoli commerciali portano il piè di pagina mentre aggiorna l'impulso tra i posizionamenti.",
    "match_centre_3": "Centro di corrispondenza",
    "match_centre_telemetry": "Telemetria del centro di corrispondenza",
    "fixture_cards_and_live_status_widgets_prioritize_active_court": "Carte di fissaggio e widget di stato dal vivo priorità campo attivo e momenti di corso.",
    "welcome_screen_3": "Schermo di benvenuto",
    "arrival_and_welcome_ambience": "Arrivo e accoglienza ambiente",
    "hero_greeting_weather_highlights_and_next_tee_times_greet": "Saluto Eroe, meteorologia, e le prossime ore salutano i soci all'ingresso.",
    "split_view_2": "Vista di Spalato",
    "dual_feed_split_view": "Doppia visualizzazione di alimentazione",
    "competition_feed_runs_beside_sponsor_inventory_for_balanced_engagement": "I mangimi della concorrenza si trovano accanto all'inventario degli sponsor per un impegno equilibrato.",
    "sponsor_advert_card_2": "Sponsor carta pubblicitaria",
    "full_sponsor_card_feature": "Caratteristiche della carta di sponsor completa",
    "high_impact_sponsor_creative_sits_front_and_center_with": "Sponsor ad alto impatto creativo si siede davanti e centro con inquadratura premium.",
    "player_spotlight_mode": "Modalità di faretto del giocatore",
    "athlete_profile_treatment_with_live_ranking_and_next_up": "Trattamento del profilo atletico con classifica live e callout successivi.",
    "final_group_hole_16": "Gruppo finale · buca 16",
    "court_1_semi_final": "Corte 1 semifinale",
    "final_group_hole_12": "Gruppo finale · buca 12",
    "court_2_quarter_final": "Corte 2 Quarter Final",
    "final_group_hole_8": "Gruppo finale · buca 8",
    "final_group_entering_signature_par_3_live_camera_window": "Gruppo finale che entra firma par-3 finestra telecamera dal vivo.",
    "court_1_semi_final_entering_decisive_set_tie_break": "Corte 1 semifinale che entra in decisivo set tie-break.",
    "hospitality_terrace_now_open_for_finals_spectators": "Ospitalità terrazza ora aperta per gli spettatori finali.",
    "on_fire": "Il fuoco",
    "closing_hole": "buca di chiusura",
    "bounce_back_momentum": "Momento di rimbalzo",
    "ethan_birdie_on_15": "Ethan birdie su 15",
    "crowd_surge_at_center_court": "Chilometraggio al centro di corte",
    "lucas_chip_in_replay": "Riproduzione di chip-in lucas",
    "semi_final_tie_break_begins": "Inizia la tie-break finale",
    "spotlight_switch_to_hole_16": "Interruttore di luce a buca 16",
    "leaderboard_focus_4": "Focus leaderboard",
    "match_focus": "Focus sulla partita",
    "finals_mode": "Modalità delle finali"
  }
};
